import { useTranslation } from 'react-i18next';
import { PersonalPropertyItem } from '../../generated/graphql';
import { AmountTable, AmountTableProps } from './Table';

interface PersonalPropertyItemsTableContainerProps
  extends Pick<
    AmountTableProps,
    'title' | 'className' | 'hideOnEmpty' | 'isLoading' | 'tableRowsContainerClassName' | 'tableTitleClassName'
  > {
  personalPropertyItemArray?: PersonalPropertyItem[];
  onItemClicked?: (a: { personalPropertyItem: PersonalPropertyItem }) => void;
  children?: (p: { personalPropertyItem: PersonalPropertyItem }) => React.ReactNode;
}

export const PersonalPropertyItemsTableContainer = ({
  children,
  onItemClicked,
  personalPropertyItemArray,
  ...props
}: PersonalPropertyItemsTableContainerProps) => {
  const { t: tCommon } = useTranslation('common');

  return (
    <AmountTable
      hideOnEmpty={props.hideOnEmpty ?? true}
      title={props.title ?? tCommon('personal-property-items')}
      {...props}
    >
      {personalPropertyItemArray
        ?.sort((a, b) => a.name.localeCompare(b.name))
        .map((personalPropertyItem) => children?.({ personalPropertyItem }))}
    </AmountTable>
  );
};
